import _ from 'lodash'
import { Module } from 'vuex'

import { RootState } from '../../types'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { initialViewState, ViewState,  } from './types'

export const view: Module<ViewState, RootState> =  {
  namespaced: true,
  state: _.cloneDeep(initialViewState),
  actions,
  getters,
  mutations,
}
